import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'orderBy'
})
export class OrderByPipe implements PipeTransform {

    transform(array: any[], field: string): any[] {
        array.sort((a: any, b: any) => {
            console.log('failed to sort ', a, field);
            if (a[field]) {
                return a[field].compare(b[field]);
            } else {
                return 0;
            }
        });
        return array;
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/order-by.pipe.ts